interface PaginationOptions {
  total?: number;
  offset?: number;
  setOffset?: (offset: number) => void;
  limit?: number;
  showPagination?: boolean;
}

export function usePagination({
  total,
  offset,
  setOffset,
  limit = 20,
  showPagination = false,
}: PaginationOptions) {
  const paginationData =
    showPagination && total && offset !== undefined && setOffset
      ? {
          offset,
          limit,
          total,
          setOffset,
        }
      : undefined;

  return { paginationData };
}
